import { FieldDocumentsDependencies } from '../../components/CompanyProfileModulesWrapper/types';

export const fieldDocumentsDependencies: FieldDocumentsDependencies = {
  fullName: ['egrul'],
  shortName: [],
  kpp: ['egrul', 'registration'],
  legalAddress: ['egrul'],
  postalAddress: [],
  settlementsCurrency: [],
  representativeFullName: ['egrul', 'decision'],
  jobTitle: [],
  actionReason: [],
  availabilityEdo: [],
  operatorEdo: [],

  registration: [],
  egrul: [],
  company_card: [],
  charter: [],
  decision: [],
};
